"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Anchor = (0, _styledComponents["default"])(_slice.Anchor)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  display: inline-block;\n\n  svg {\n    display: block;\n    width: 220px;\n    height: auto;\n  }\n"], ["\n  display: inline-block;\n\n  svg {\n    display: block;\n    width: 220px;\n    height: auto;\n  }\n"])));
exports.Anchor = Anchor;
var templateObject_1;